/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationEvaluationOptionDto } from './EnumerationEvaluationOptionDto';
import {
    EnumerationEvaluationOptionDtoFromJSON,
    EnumerationEvaluationOptionDtoFromJSONTyped,
    EnumerationEvaluationOptionDtoToJSON,
} from './EnumerationEvaluationOptionDto';

/**
 * 
 * @export
 * @interface EnumerationEvaluationParameterDto
 */
export interface EnumerationEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationEvaluationParameterDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {Array<EnumerationEvaluationOptionDto>}
     * @memberof EnumerationEvaluationParameterDto
     */
    options?: Array<EnumerationEvaluationOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    $type?: EnumerationEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersEnumerationEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationEvaluationParameterDtoTypeEnum = typeof EnumerationEvaluationParameterDtoTypeEnum[keyof typeof EnumerationEvaluationParameterDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationEvaluationParameterDto interface.
 */
export function instanceOfEnumerationEvaluationParameterDto(value?: unknown): value is EnumerationEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationEvaluationParameterDtoTypeEnum)[0];
}

export function EnumerationEvaluationParameterDtoFromJSON(json: any): EnumerationEvaluationParameterDto {
    return EnumerationEvaluationParameterDtoFromJSONTyped(json, false);
}

export function EnumerationEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationEvaluationParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'allowRepetition': !exists(json, 'allowRepetition') ? undefined : json['allowRepetition'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'options': !exists(json, 'options') ? undefined : (json['options'] === null ? null : (json['options'] as Array<any>).map(EnumerationEvaluationOptionDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationEvaluationParameterDtoToJSON(value?: EnumerationEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'dataTypeId': value.dataTypeId,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'allowRepetition': value.allowRepetition,
        'origin': EntityOriginToJSON(value.origin),
        'instruction': value.instruction,
        'options': value.options === undefined ? undefined : (value.options === null ? null : (value.options as Array<any>).map(EnumerationEvaluationOptionDtoToJSON)),
        '$type': value.$type,
    });
}

